<div class="row no-gutters">
    <span class="io-preview-text-description">Click Create Order to create a new IO in Campaigns</span>
</div>

<hr class="io-header-body-separator">

<div class="row create-order-btn" title="{{ disabledButtonTitleText || ''}}">
    <acl-ngx-button (click)="sendToCampaigns()" contentClass="margin-5 float-right" variant="primary"
        [className]="(waitingForActivation || disableButtonWhenPlanHasPastDate || disableButtonWhenLessMaxBid) ? 'create-order-btn-disable' : ''"
        [label]="buttonLabel">
    </acl-ngx-button>
</div>

<div class="row io-preview-data-table">
    <ccp-data-table [tableConfigs]="ioPreviewTableConfigs" [columns]="ioPreviewColumns" class="table-min-height">
    </ccp-data-table>
</div>

<amobee-loader *ngIf="waitingForActivation" loading="true"></amobee-loader>